__turbopack_context__.v({
  "className": "inter_394d8b56-module__gDtpIG__className",
});
